import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../Styles/forms.css"
const PatientTapasanyaForm = (props) => {

  const { initialValues, onSubmit } = props;
const navigate = useNavigate();
  const patientTapasanyaInfo = props.initialValues.patientTapasanya?.[0] || {};
  
  // Define the form's initial values
  const formInitialValues = {
    VISIT_DATE: patientTapasanyaInfo?.VISIT_DATE ? patientTapasanyaInfo.VISIT_DATE.substring(0, 10) : "",
    PATIENT_TAPASANYA: patientTapasanyaInfo?.PATIENT_TAPASANYA || "",
    PATIENT_WEIGHT: patientTapasanyaInfo?.PATIENT_WEIGHT || "",
    PATIENT_BP: patientTapasanyaInfo?.PATIENT_BP || "",
    PATIENT_PULSERATE: patientTapasanyaInfo?.PATIENT_PULSERATE || 0,
  };

  // Define the validation schema
  const validationSchema = Yup.object().shape({
  //  PATIENT_TAPASANYA: Yup.string().nullable(true),
    VISIT_DATE: Yup.date(),
    PATIENT_WEIGHT: Yup.string(),
    PATIENT_BP: Yup.string(),
    PATIENT_PULSERATE: Yup.number().integer(),
  });

  return (
    <div className="tapasanya-form-wrapper">
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values); // Pass form values to the parent component's onSubmit function
        setSubmitting(false);
      }}
    >
      <Form className="tapasanya-form">
        <div className="tapasanya-form-group">
          <label htmlFor="VISIT_DATE">Visit Date</label>
          <Field name="VISIT_DATE" type="date" className="tapasanya-form-control" />
          <ErrorMessage name="VISIT_DATE" component="div" className="invalid-feedback" />
        </div>
  
        <div className="tapasanya-form-group">
          <label htmlFor="PATIENT_TAPASANYA">Tapasanya</label>
          <Field name="PATIENT_TAPASANYA" as="textarea" className="tapasanya-form-control" />
          <ErrorMessage name="PATIENT_TAPASANYA" component="div" className="invalid-feedback" />
        </div>
  
        <div className="tapasanya-form-group">
          <label htmlFor="PATIENT_WEIGHT">Weight</label>
          <Field name="PATIENT_WEIGHT" type="text" className="tapasanya-form-control" />
          <ErrorMessage name="PATIENT_WEIGHT" component="div" className="invalid-feedback" />
        </div>
  
        <div className="tapasanya-form-group">
          <label htmlFor="PATIENT_BP">Blood Pressure</label>
          <Field name="PATIENT_BP" type="text" className="tapasanya-form-control" />
          <ErrorMessage name="PATIENT_BP" component="div" className="invalid-feedback" />
        </div>
  
        <div className="tapasanya-form-group">
          <label htmlFor="PATIENT_PULSERATE">Pulse Rate</label>
          <Field name="PATIENT_PULSERATE" type="number" className="tapasanya-form-control" />
          <ErrorMessage name="PATIENT_PULSERATE" component="div" className="invalid-feedback" />
        </div>
        <div className="form-buttons">
            <button type="button" className="btn-back" onClick={() => navigate(-1)}>Back</button>
            <button type="submit" className="btn-next">Next</button>
          </div>
      </Form>
    </Formik>
  </div>  
  );
};

export default PatientTapasanyaForm;
